import * as React from 'react';
import { Icon } from 'antd';
import { tokens } from 'src/design-system';
import { getLookupNotes, LookupCardData } from './lookupNotes';

interface LookupNotesProps {
  cardData: LookupCardData;
}

// ISS-295744: ⓘ notes under the card's tracking (BL/booking not found, container details pending).
// File is named LookupNotesView (not LookupNotes) because lookupNotes.ts sits beside it and the
// extension order (.ts before .tsx) would resolve `./LookupNotes` to the .ts file on case-insensitive filesystems.
const LookupNotes = ({ cardData }: LookupNotesProps) => {
  const notes = getLookupNotes(cardData);
  if (!notes.length) return null;
  return (
    <div style={{ marginLeft: tokens.spacing.md }}>
      {notes.map((note) => (
        <div key={note.key} style={{ color: tokens.colors.textTertiary, fontSize: tokens.fontSize.small }}>
          <Icon type="info-circle" style={{ marginRight: tokens.spacing.sm }} />
          {note.text}
        </div>
      ))}
    </div>
  );
};

export default LookupNotes;
